import { component } from 'picoapp';
import Drawer from '~/js/utils/drawer';

const getDistance = (lat1, lon1, targetLat, targetLon) => {
  const radlat1 = (Math.PI * lat1) / 180;
  const radlat2 = (Math.PI * targetLat) / 180;

  const theta = lon1 - targetLon;
  const radtheta = (Math.PI * theta) / 180;

  let dist = Math.sin(radlat1) * Math.sin(radlat2)
    + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist *= 1.609344;

  return dist;
};

export default component(async (node) => {
  const { key } = node.dataset;
  const drawer = Drawer(node, true, true);
  const drawerTriggers = [...document.querySelectorAll(`[data-drawer-trigger="${key}"]`)];
  const drawerClosers = [...node.querySelectorAll('[data-action="close"]')];
  const stores = node.querySelectorAll('.store-item');

  const searchInput = node.querySelector('input[data-action="search"]');
  const locateButton = node.querySelector('button[data-action="locate"]');
  const selectionWrapper = node.querySelector('[data-selection]');
  const collectionActiveSelection = document.querySelector('[data-active-selection]');
  const selectionDefault = selectionWrapper.textContent;
  const selectedStores = localStorage.getItem('selectedStores')?.split(',') || [];
  const toggleStoreFilter = document.querySelector('input[data-toggle-stores]');

  const locationData = Array.from(stores).map((store) => {
    const coordinates = store.dataset.coordinates.replace(/\s/g, '').split(',');

    return {
      name: store.dataset.name,
      value: store.dataset.value,
      address: store.dataset.address,
      id: store.dataset.id,
      el: store,
      latitude: parseFloat(coordinates[0]),
      longitude: parseFloat(coordinates[1]),
      distance: 0,
    };
  });

  const setActiveStores = () => {
    selectionWrapper.innerHTML = '';
    collectionActiveSelection.innerHTML = '';
    const activeIds = [];
    locationData.forEach((store) => {
      if (store.el.classList.contains('active')) {
        activeIds.push(store.value);
        const html = `<div data-active-label data-id="${store.id}" class="capitalize tw-m-1 rounded-2 bg-warm-gray-100 tw-px-2 tw-py-1 text-12 font-semibold text-warm-gray-600 flex items-center">
${store.name}
<svg class="tw-ml-3 pointer-events-none" xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
<path d="M9 1.5L1 9.5M9 9.5L1 1.5" stroke="#272219" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</div>`;
        selectionWrapper.insertAdjacentHTML('beforeend', html);
        collectionActiveSelection.insertAdjacentHTML('beforeend', html);
      }
    });

    if (!activeIds.length) {
      selectionWrapper.innerHTML = selectionDefault;
      collectionActiveSelection.innerHTML = '';
      collectionActiveSelection.parentElement.classList.remove('border-black');
      collectionActiveSelection.parentElement.classList.add('border-warm-gray-200');
    } else {
      collectionActiveSelection.parentElement.classList.add('border-black');
      collectionActiveSelection.parentElement.classList.remove('border-warm-gray-200');
    }

    const activeLabels = document.querySelectorAll('[data-active-label]');

    activeLabels.forEach((item) => {
      item.addEventListener('click', () => {
        const toRemove = locationData.find((store) => store.id === item.dataset.id);

        toRemove.el.classList.remove('active');
        setActiveStores();
        document.dispatchEvent(new Event('store:selected'));
      });
    });

    localStorage.setItem('selectedStores', activeIds.join(','));
  };

  if ('geolocation' in navigator) {
    locateButton.addEventListener('click', () => {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        locationData.forEach((loc) => {
          loc.distance = getDistance(loc.latitude, loc.longitude, latitude, longitude);
        });

        const sorted = locationData.sort((a, b) => a.distance - b.distance);

        sorted.forEach((store, idx) => {
          store.el.style.order = idx;
        });
      });
    });
  } else {
    locateButton.remove();
  }

  locationData.forEach((store) => {
    const button = store.el.querySelector('button[data-add]');

    if (selectedStores.includes(store.value)) {
      store.el.classList.add('active');
      document.dispatchEvent(new Event('store:selected'));
    }

    button.addEventListener('click', () => {
      store.el.classList.toggle('active');
      setActiveStores();
      document.dispatchEvent(new Event('store:selected'));
    });
  });

  setActiveStores();

  searchInput.addEventListener('input', () => {
    if (searchInput.value.length === 0) {
      locationData.forEach((store) => {
        store.el.hidden = false;
      });
      return;
    }

    const query = searchInput.value.trim().toLowerCase();

    const results = locationData.filter((store) => store.address.includes(query) || store.name.includes(query));
    locationData.forEach((store) => {
      store.el.hidden = true;
    });
    results.forEach((store) => {
      store.el.hidden = false;
    });
  });

  drawer.on('close', () => {
    const tmpSelectedStores = localStorage.getItem('selectedStores') ? localStorage.getItem('selectedStores').split(',') : [];
    toggleStoreFilter.checked = tmpSelectedStores.length > 0;
  });

  // Listen to drawer-triggers
  if (drawerTriggers.length) {
    drawerTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.toggle();
      });
    });
  }

  // Listen to drawer-closers
  if (drawerClosers.length) {
    drawerClosers.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.close();
      });
    });
  }
});
